import { useLocation } from 'react-router-dom';
import RegistrationForm from '#app/pages/CreateAccount/RegistrationForm/RegistrationForm';
import RegistrationLayout from '#app/layouts/RegistrationLayout';

interface Props {}

function AccountDetails(props: Props) {
  const { state } = useLocation();

  return (
    <RegistrationLayout>
      <RegistrationForm defaultValues={state.data}></RegistrationForm>
    </RegistrationLayout>
  );
}

export default AccountDetails;
